import React from 'react';
import { bool, func, number, shape, string } from 'prop-types';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { styled } from '@mui/material/styles';
import { useUserRolePermissions } from 'hooks';
import { isAuthSequencingUpdatesEnabled } from 'feature/loading-management/utils/const';

const ButtonProgress = styled(CircularProgress)(({ theme }) => ({
  bottom: 0,
  color: theme.palette.secondary.main,
  left: 0,
  margin: 'auto',
  pointerEvents: 'none',
  position: 'absolute',
  right: 0,
  top: 0,
}));

const FilterCounter = styled('span')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: 2,
  color: theme.palette.primary.main,
  display: 'flex',
  fontSize: 12,
  height: 16,
  justifyContent: 'center',
  marginLeft: theme.spacing(1),
  padding: 2,
  width: 14,
}));

const launchButtonStyles = { cursor: 'pointer', marginLeft: theme => theme.spacing(3) };

const HeaderButtons = ({
  authorizationSequencingPending,
  hasWizardAccess,
  filtersOpen,
  filtersRef,
  filterIdentifierCount,
  isSequencingWizardEnabled,
  setFiltersOpen,
  setWizardOpen,
  tooltip,
}) => {
  const { isProductLoadingManage } = useUserRolePermissions();
  // Feature flag: REACT_APP_LD_SEQUENCING_AUTH_LIST
  const isAuthSequencingUpdatesFlagOn = isAuthSequencingUpdatesEnabled();

  return (
    <>
      {!isAuthSequencingUpdatesFlagOn && (
        <Button
          disabled={authorizationSequencingPending}
          onClick={() => setFiltersOpen(!filtersOpen)}
          onClose={() => setFiltersOpen(false)}
          ref={filtersRef}
          variant="text"
        >
          Filters
          {filterIdentifierCount >= 1 && <FilterCounter>{filterIdentifierCount}</FilterCounter>}
          {filtersOpen ? (
            <ExpandLessRoundedIcon position="right" variation="buttonsChild" />
          ) : (
            <ExpandMoreRoundedIcon position="right" variation="buttonsChild" />
          )}
        </Button>
      )}
      {isSequencingWizardEnabled && isProductLoadingManage && (
        <Tooltip
          disableHoverListener={hasWizardAccess}
          enterTouchDelay={10}
          placement="top"
          title={tooltip}
        >
          <div>
            <Button
              disabled={authorizationSequencingPending || !hasWizardAccess}
              onClick={() => setWizardOpen(true)}
              sx={launchButtonStyles}
            >
              {authorizationSequencingPending && <ButtonProgress size={14} />}
              Launch Sequencing Wizard
            </Button>
          </div>
        </Tooltip>
      )}
    </>
  );
};

HeaderButtons.propTypes = {
  authorizationSequencingPending: bool.isRequired,
  filterIdentifierCount: number.isRequired,
  filtersOpen: bool.isRequired,
  filtersRef: shape({}).isRequired,
  hasWizardAccess: bool.isRequired,
  isSequencingWizardEnabled: bool.isRequired,
  setFiltersOpen: func.isRequired,
  setWizardOpen: func.isRequired,
  tooltip: string.isRequired,
};

export default HeaderButtons;
